import * as types from './actionTypes';
import restaurantApi from './api';

export const fetchRestaurants = () => {
  return (dispatch, getState) => {
    const isAllowedCity = !getState().city.waitOpenings;

    if (!isAllowedCity) {
      return null;
    }

    dispatch({ type: types.FETCH_LIST_REQUEST });

    return restaurantApi
      .getRestaurants()
      .then(data => {
        return dispatch({ type: types.FETCH_LIST_SUCCESS, payload: data });
      })
      .catch(({ message }) => {
        return dispatch({ type: types.FETCH_LIST_FAILURE, payload: message });
      });
  };
};

export function fetchStopList(restaurant_id) {
  return dispatch => {
    dispatch({ type: types.FETCH_RESTAURANT_STOPLIST_REQUEST });

    return restaurantApi
      .getRestaurantStopList(restaurant_id)
      .then(data => {
        return dispatch({ type: types.FETCH_RESTAURANT_STOPLIST_SUCCESS, payload: data });
      })
      .catch(({ message }) => {
        return dispatch({ type: types.FETCH_RESTAURANT_STOPLIST_FAILURE, payload: message });
      });
  };
}

export const clearRestaurantStopList = () => ({
  type: types.CLEAR_RESTAURANT_STOPLIST,
});

export function fetchRestsForSale() {
  return dispatch => {
    return restaurantApi
      .getRestaurantsForSale()
      .then(data => {
        return dispatch({ type: types.FETCH_LIST_FOR_SALE_REQUEST, payload: data });
      })
      .catch(() => {
        return ;
      });
  };
}

export function sendFranchiseForm(data){
  return restaurantApi.sendFormForSale(data)
}
